export default "__VITE_ASSET__CTKNM6Rj__"